import * as React from 'react';

function SvgEnterprise(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
      <path d="M14 2.65V5h6.25c.41 0 .75.34.75.75v15.5c0 .41-.34.75-.75.75H17v-4h-3v4h-3.25a.75.75 0 01-.75-.75V5.75c0-.41.34-.75.75-.75h1.75V3.5h-9v17.75a.75.75 0 01-1.5.1V2.75c0-.38.28-.7.65-.74l.1-.01h10.5c.38 0 .7.28.74.65zM20 6h-9v15h2v-3.25c0-.41.34-.75.75-.75h3.5c.41 0 .75.34.75.75V21h2V6zM8.5 12.5a.5.5 0 01-.5.5H3v-1h5c.28 0 .5.22.5.5zm0 3a.5.5 0 01-.5.5H3v-1h5c.28 0 .5.22.5.5zm0 3a.5.5 0 01-.5.5H3v-1h5c.28 0 .5.22.5.5zM15 14v1.5h-2V14h2zm3 0v1.5h-2V14h2zm-3-3v1.5h-2V11h2zm3 0v1.5h-2V11h2zM8.5 9.5a.5.5 0 01-.5.5H3V9h5c.28 0 .5.22.5.5zM15 8v1.5h-2V8h2zm3 0v1.5h-2V8h2zM8.5 6.5A.5.5 0 018 7H3V6h5c.28 0 .5.22.5.5z" />
    </svg>
  );
}

export default SvgEnterprise;
